const Quote = () => (
  <div className="quote">
    <p>
      As far as the laws of mathematics refer to reality, they are not certain,
      and as far as they are certain, they do not refer to reality. — Albert
      Einstein
    </p>
  </div>
);

export default Quote;
